import React, {useState} from 'react';
import HeaderInput, {Field} from './Header';
import {EscapeElement} from './utils/utils';


function wh(e){
    if (e.target.closest('.scrollbarCustom') && (e.deltaY > 100 || e.deltaY < -100)) {
        e.target.closest('.scrollbarCustom').scrollLeft += e.deltaY
    }
}


export default function Main({id, type, dropdown, children, text, outdoor, internal, floor, alias, view, count, index, value, name, validate, result, funcResult}){

    return (              
        <div className={"snap-center w-[300px] p-5 pt-16 pb-1 sm:w-[550px] sm:p-6 sm:pt-20 shadow-xl rounded-md h-[max-content] mr-10 relative overflow-hidden"}>
            <span className="absolute left-0 right-0 m-auto top-0 text-[21px] bg-[#f4dd3a] px-10 py-1 w-max">{Number.isFinite(index) ? 'Этаж' : 'Мансарда'}</span>
                <div className="absolute top-[-202px] animate-[opacity_1s_ease-in_forwards] left-[-36px] text-[#b0b0b0] text-[450px] font-[600] z-[-1]">{index}</div>
                <div className="grid grid-cols-[repeat(1,_1fr))] sm:grid-cols-[repeat(auto-fit,_minmax(0,_1fr))] gap-6">
                    {text.map( (el,index) => {  
                        return <HeaderInput key={el.id} fontSize={'14px'} type={type} text={el.text} id={el.id} dropdown={el.dropdown} children={children} value={value} name={el.name} validate={validate} funcResult={funcResult}/>            
                    })}
                </div>
                <div className="relative rounded-xl overflow-auto mt-5">
                    <div className="">  
                        <div className="flex flex-col-reverse md:flex-row mb-4">     
                            <p>{internal.text}</p>  
                            <button className="bg-[#5aad5a] hover:bg-[#2b8d2b] active:bg-[#9cc59c] transition duration-200 p-2 text-[#fff] ml-0 mr-[auto] md:ml-[auto] md:mr-2 rounded" onClick={() => floor({id,internal})}> + Добавить проем</button>
                        </div>
                        <div onWheel={wh} className={(internal.defaultFields.length >= 2 ? "overscroll-contain" : '') + " scrollbarCustom flex flex-col flex-wrap w-[100%] max-h-[350px] relative w-full flex gap-5 snap-x overflow-x-auto w-max"}>          
                            {internal.defaultFields.map( (el,index, arrgs) => {                
                                return el.map( (elem, ind, arr) => {  
                                    //const countElem = arrgs.length < 3 ? `calc(100% / ${arrgs.length})` : '40%';
                                    return <Field key={elem.id} fontSize={'14px'} text={elem.text} id={elem.id} allId={elem.allId} button={ind === arr.length - 1 ? true: false} view={view} value={value} name={elem.name} validate={validate}/> 
                                });                            
                            })}
                        </div>                   
                    </div>
                </div>
                <div className="relative rounded-xl overflow-auto mt-5">
                    <div className=""> 
                        <div className="flex flex-col-reverse md:flex-row mb-4">     
                            <p>{outdoor.text}</p>  
                            <button className="bg-[#5aad5a] hover:bg-[#2b8d2b] active:bg-[#9cc59c] transition duration-200 p-2 text-[#fff] ml-0 mr-[auto] md:ml-[auto] md:mr-2 rounded" onClick={() => floor({id,outdoor})}> + Добавить проем</button>
                        </div>
                        <div onWheel={wh} className="overscroll-contain scrollbarCustom flex flex-col flex-wrap w-[100%] max-h-[350px] relative w-full flex gap-5 snap-x overflow-x-auto w-max">                 
                            {outdoor.defaultFields.map( (el,index) => {                        
                                return el.map( (elem, ind, arr) => {                      
                                    return <Field key={elem.id}  fontSize={'14px'} text={elem.text} id={elem.id} allId={elem.allId} button={ind === arr.length - 1 ? true: false} view={view} value={value} name={elem.name} validate={validate}/> 
                                });
                            })}
                        </div>                   
                    </div>
                </div>

                <div onClick={() => view(id)} className="absolute right-2 top-2 rotate-45">
                    <EscapeElement absolute={''} color={'#d52020'} translateY={'50%'} translateX={'50%'} rotate={'45deg'}/>
                </div>
        </div>
    );
}